package pt.at.oss.kotlin.manual.schema.common.supplycommencement

import pt.at.oss.kotlin.manual.storage.common.supplycommencement.SupplyCommencement
import pt.lightweightform.kotlin.schema.BooleanSchema
import pt.lightweightform.kotlin.schema.DateStringSchema
import pt.lightweightform.kotlin.schema.RecordSchema
import pt.lightweightform.kotlin.type.validator.ValidationErrors

/**
 * SupplyCommencementSchema Schema object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
class SupplyCommencementSchema : RecordSchema<SupplyCommencement>(name = "supplyCommencement") {

    val alreadyCarriedOutSuppliesSchema: BooleanSchema = BooleanSchema(name = "alreadyCarriedOutSupplies")
    val commencementDateSchema: DateStringSchema = DateStringSchema(name = "commencementDate")
    override fun isValid(value: SupplyCommencement?): Boolean {
        return value == null || (
            alreadyCarriedOutSuppliesSchema.isValid(value.alreadyCarriedOutSupplies) &&
                commencementDateSchema.isValid(value.commencementDate)
            )
    }

    override fun validate(value: SupplyCommencement?, path: String): ValidationErrors {
        val validator = super.validate(value, path)
        if (value === null) {
            return validator
        }
        validator.addErrors(alreadyCarriedOutSuppliesSchema.validate(value.alreadyCarriedOutSupplies))
        validator.addErrors(commencementDateSchema.validate(value.commencementDate))
        return validator
    }
}
